<template>
  <v-app>
    <div
      v-if="loading === true"
      class="text-center"
    >
      <v-progress-circular
        :size="70"
        :width="10"
        color="blue"
        indeterminate
      />
      <br>
      お客様の情報を確認中です。<br>
      処理が完了するまでお待ちください。
    </div>

    <v-alert
      v-model="alert"
      close-text="Close Alert"
      color="orange accent-4"
      dark
      dismissible
      class="ma-5"
    >
      {{ error_message }}
    </v-alert>

    <div class="text-center ma-5">
      <h2 class="display-1">
        診察券・患者様番号を登録
      </h2>
    </div>
    <div
      v-if="clinic"
      class="ma-5"
    >
      クリニックの診察券に記載されている患者様番号（{{
        clinic.patient_number
      }}桁の数字）とお名前を登録してください。診察券のお名前がカタカナの場合はカナで入力してください。
    </div>
    <v-card
      v-if="loading === false"
      width="95%"
      class="mx-auto"
    >
      <v-form class="ma-5">
        <div v-if="clinic">
          {{ clinic.name }}
        </div>
        <v-text-field
          v-if="needPhoneInput"
          v-model="input_phone"
          prepend-icon="mdi-phone"
          label="電話番号（クリニック登録と同一の番号）"
          outlined
          clearable
          hint="ハイフン・スペース不要（あっても自動で無視されます）"
        />
        <v-text-field
          v-model="patientCode"
          prepend-icon="mdi-numeric"
          label="患者番号 No. "
          outlined
          clearable
        />
        <div class="signin">
          <v-text-field
            v-model="user_name"
            prepend-icon="mdi-account"
            label="お名前 Name"
            outlined
            clearable
          />
          <v-btn
            v-if="canSubmit"
            id="submit"
            class="info"
            @click="addPatientCode"
          >
            登録
          </v-btn>
          <v-btn
            v-else
            depressed
            disabled
          >
            登録
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import { Firebase } from "../config/firebase";
export default {
  name: "PatientRegster",

  data() {
    return {
      loading: true,
      patientCode: "",
      user_name: "",
      welcome: null,
      alert: false,
      error_message: "",
      firestorage: null,
      storageRef: null,
      image_url: "",
      user_clinic: null,
      clinic: null,
      user: null,
      needPhoneInput: false,
      input_phone: "",
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    user_id() {
      return this.$store.getters.user.uid;
    },
    canSubmit() {
      if (!this.user_name || !this.clinic) return false;

      // is_fix_patient_number_lengthがtrueの場合は長さが一致していることが必須
      if (this.clinic.is_fix_patient_number_length === true) {
        if (this.patientCode.length !== this.clinic.patient_number) {
          return false;
        }
      } else {
        // 通常はpatient_number以上でOK
        if (this.patientCode.length < this.clinic.patient_number) {
          return false;
        }
      }

      // 電話番号不一致が発生して追加入力が必要なときは、電話番号の入力も必須
      if (this.needPhoneInput) {
        return this.input_phone.trim().length > 0;
      }
      return true;
    },
  },

  created: async function () {
    try {
      this.fetchClinics();
    } catch (e) {
      this.error = true;
      console.log(e);
    } finally {
      this.loading = false;
    }
    this.loading = false;
    try {
      await this.fetchUsers();
    } catch (e) {
      this.error = true;
      console.log(e);
    } finally {
      this.loading = false;
    }
    this.loading = false;
  },
  methods: {
    normalizePhone(phone) {
      if (!phone) return "";
      return String(phone).replace(/[^\d]/g, ""); // 数字以外を全除去
    },
    normalizeName(name) {
      if (!name) return "";
      // eslint-disable-next-line no-irregular-whitespace
      return String(name).replace(/[\s　]+/g, ""); // 空白除去
    },
    fetchUsers: async function () {
      const userRef = await Firebase.firestore()
        .collection("Users")
        .doc(this.$store.getters.user.uid);
      await userRef.get().then((doc) => {
        if (doc.exists) {
          this.user = doc.data();
          this.user.id = doc.id;
        } else {
          console.log("No user document!");
        }
        this.error = true;
      });
    },
    fetchClinics: async function () {
      try {
        const clinicRef = await Firebase.firestore()
          .collection("Clinics")
          .doc(this.id);
        await clinicRef.get().then((doc) => {
          if (doc.exists) {
            this.clinic = doc.data();
            this.clinic.id = doc.id;
          } else {
            console.log("No clinic document!");
          }
          this.error = true;
        });
      } catch (e) {
        this.error = true;
        this.$router.push({
          name: "error",
          params: { message: "表示できません。" },
        });
      } finally {
        this.loading = false;
      }
    },
    async addPatientCode() {
      this.alert = false;
      this.loading = true;

      // すでにユーザーが同じ患者番号を登録済みかチェック
      try {
        const dupSnap = await Firebase.firestore()
          .collection("Patients")
          .where("clinic_id", "==", this.clinic.id)
          .where("patientNumber", "==", this.patientCode)
          .where("user_id", "==", this.user_id)
          .get();

        if (!dupSnap.empty) {
          this.error_message = "すでに登録済みです。";
          this.alert = true;
          this.loading = false;
          this.$router.push({
            name: "priscription_list",
            params: { id: this.id },
          });
          return;
        }
      } catch (error) {
        this.loading = false;
        throw new Error(
          new Date().toLocaleString("ja") +
            " [erro code: 121] getGetwayList: gateway/list error" +
            error,
        );
      }

      const patientRef = Firebase.firestore().collection("Patients");
      // クリニック内で患者番号が存在するか確認（存在したら名前照合）
      let existingPatientDoc = null;
      try {
        const qs = await patientRef
          .where("clinic_id", "==", this.id)
          .where("patientNumber", "==", this.patientCode)
          .limit(1)
          .get();

        if (!qs.empty) {
          existingPatientDoc = qs.docs[0];

          // ★ 電話番号チェックが必要なクリニックだけ比較
          if (this.clinic.is_phonenumber === true) {
            const dbPhone = this.normalizePhone(
              existingPatientDoc.data().phoneNumber,
            );
            // ★ 1回目：ユーザープロファイルの電話（this.user.phone）と比較
            const inputOrUserPhone = this.needPhoneInput
              ? this.normalizePhone(this.input_phone) // 2回目以降は入力値で再比較
              : this.normalizePhone(this.user.phone);

            if (dbPhone !== inputOrUserPhone) {
              // 不一致 → 電話番号入力を促し、次回の submit で再チェック
              this.error_message =
                "施設で登録した際の電話番号を入力してください（ハイフン・スペースは不要です）";
              this.alert = true;
              this.needPhoneInput = true; // ★ 入力欄を表示
              this.loading = false;
              return; // 中断
            }
          }

          // ★ 名前チェックが必要なクリニックだけ比較
          if (this.clinic.is_name_check === true) {
            const dbName = this.normalizeName(existingPatientDoc.data().name);
            const dbKana = this.normalizeName(existingPatientDoc.data().kana);
            const inputName = this.normalizeName(this.user_name);

            if (inputName !== dbName && inputName !== dbKana) {
              this.error_message =
                "施設で登録した際のお名前（漢字またはカナ）を入力してください";
              this.alert = true;
              this.loading = false;
              return; // 中断
            }

            // 名前の一致確認が取れたので、ユーザー情報を更新する（入力値と異なる場合）
            if (this.user.name !== this.user_name) {
              try {
                await Firebase.firestore()
                  .collection("Users")
                  .doc(this.user_id)
                  .update({ name: this.user_name });
                this.user.name = this.user_name; // ローカルも反映
              } catch (e) {
                console.error("Users name update error:", e);
              }
            }
          }
        }
      } catch (e) {
        console.error("Patients search error:", e);
      }

      // ★ 電話番号の上書き：不一致→一致で通過した場合のみ更新
      if (this.needPhoneInput && this.input_phone) {
        const newPhoneRaw = this.input_phone.trim();
        if (newPhoneRaw && this.user.phone !== newPhoneRaw) {
          try {
            await Firebase.firestore()
              .collection("Users")
              .doc(this.user_id)
              .update({ phone: newPhoneRaw });
            this.user.phone = newPhoneRaw; // ローカルも反映
          } catch (e) {
            console.error("Users phone update error:", e);
            // 失敗しても登録自体は続けたい場合は何もしない／止めたい場合はreturn
          }
        }
      }

      // 既存患者がいる場合は氏名照合（不一致ならエラー表示して中断）
      if (existingPatientDoc) {
        /* 診察券の名前を厳密に付き合わせする
        const db = existingPatientDoc.data() || {};
        const inputName = this.normalizeName(this.user_name);
        const dbName = this.normalizeName(db.name);
        if (dbName && inputName && dbName !== inputName) {
          this.error_message = "診察券に記載されているお名前を入力してください";
          this.alert = true;
          this.loading = false;
          return; // ★ 中断
        }
      */

        // 一致 or データベース側の name 未設定 → ユーザー紐づけ更新
        this.user_clinic = {
          clinic_id: this.id,
          clinic_name: this.clinic.name,
          patient_id: existingPatientDoc.id,
          patientNumber: this.patientCode,
          patient_name: this.user_name,
        };

        try {
          await patientRef.doc(existingPatientDoc.id).update({
            user_id: this.user.id,
            email: this.user.email,
            kana: "",
            name: this.user_name, // DB未設定 or 同名なら更新してOK
            phoneNumber: this.user.phone,
            status: true,
            is_self_regist: true,
            timestamp: Firebase.firestore.FieldValue.serverTimestamp(),
          });
        } catch (error) {
          console.error("Error update document: ", error);
        }
      } else {
        // 既存患者がいない → 新規作成
        const patient = {
          clinic_id: this.clinic.id,
          clinic_name: this.clinic.name,
          user_id: this.user.id,
          email: this.user.email,
          kana: "",
          name: this.user_name,
          patientNumber: this.patientCode,
          phoneNumber: this.user.phone,
          status: true,
          is_self_regist: true,
          timestamp: Firebase.firestore.FieldValue.serverTimestamp(),
        };

        try {
          const doc = await patientRef.add(patient);
          patient.id = doc.id;
          this.user_clinic = {
            clinic_id: this.clinic.id,
            clinic_name: this.clinic.name,
            patient_id: patient.id,
            patientNumber: this.patientCode,
            patient_name: this.user_name,
          };
        } catch (error) {
          console.error("Error adding document: ", error);
        }
      }

      // Users.clinics に追加
      try {
        await Firebase.firestore()
          .collection("Users")
          .doc(this.user_id)
          .update({
            clinics: Firebase.firestore.FieldValue.arrayUnion(this.user_clinic),
          });
      } catch (e) {
        console.error("Users update clinics error:", e);
      }

      this.loading = false;
      this.$router.push({ name: "priscription_list", params: { id: this.id } });
    },
  },
};
</script>
